import { type ReactNode } from 'react';
import classNames from 'classnames';

import { REPUBS } from '@cx-modules/constants';
import { type Repub } from '@cx-modules/types';

import { Button } from '../cxy';

import styles from './styles/HeaderItems.module.css';

export const plusLinks = ({
  isTipstersEnabled,
  repub



}: {isTipstersEnabled: boolean;repub: Repub;}) => {
  const urlPrefix = `/${repub === REPUBS.US.name ? `${repub.toLowerCase()}/` : ''}plus/`;

  const positiveValue = {
    [REPUBS.US.name]: {
      href: `${urlPrefix}positive-ev`,
      link: 'Positive Value Bets'
    },
    [REPUBS.OC.name]: {
      href: `${urlPrefix}value-bets`,
      link: 'Value Bets'
    }
  };

  const bettingSplits = {
    [REPUBS.US.name]: {
      href: `${urlPrefix}betting-splits`,
      link: 'Public Betting Splits'
    },
    [REPUBS.OC.name]: {
      href: `${urlPrefix}betting-splits`,
      link: 'Public Betting Splits'
    }
  };

  const trends = {
    [REPUBS.US.name]: {
      href: `${urlPrefix}trends`,
      link: 'Trends'
    },
    [REPUBS.OC.name]: {
      href: `${urlPrefix}trends`,
      link: 'Trends'
    }
  };

  const tips = {
    [REPUBS.OC.name]: {
      href: `${urlPrefix}premium-tipsters`,
      link: 'Premium Tipsters'
    }
  };

  return [
  positiveValue[repub],
  bettingSplits[repub],
  trends[repub],
  isTipstersEnabled && tips[repub]].
  filter(Boolean);
};

type LinkItem = {
  className: string;
  href: string;
  link: ReactNode;
};

export const HeaderItems = ({
  baseUrl,
  currentPathWithRepub,
  isTipstersEnabled,
  repub,
  resourcesUrl






}: {baseUrl: string;currentPathWithRepub: string;isTipstersEnabled: boolean;repub: Repub;resourcesUrl: string;}) => {
  const links = [
  {
    href: baseUrl,
    className: styles.logo,
    link:
    <img
      alt="OddsChecker"
      src={`${resourcesUrl}/assets/img/oc-pro-logo.svg`} />


  },
  ...plusLinks({ repub, isTipstersEnabled })] as
  LinkItem[];

  return (
    <ul className={styles.links}>
			{Object.values(links).map((item, index) =>
      <li
        className={classNames(
          styles.linkItem,
          currentPathWithRepub === item.href ? styles.isSelected : null,
          { [item.className]: item.className }
        )}
        key={`navigation-item-${index}`}>

					<Button asChild size="large">
						<a href={item.href}>{item.link}</a>
					</Button>
				</li>
      )}
		</ul>);

};